import { Navigate, Outlet } from "react-router-dom";

export default function ExternalRoutes({ externalAuth }) {
  return externalAuth ? <Outlet /> : <Navigate to="/notauthorized" />;
}
